<template>
    <div class="summaryPair_wrap">
        <div class="summaryPair-title">
            <div class="summaryPair-titleItem">ПАРА</div>
            <div class="summaryPair-titleItem">%</div>
            <div class="summaryPair-titleItem">PIP</div>
            <div class="summaryPair-titleItem">% УСПЕШНЫХ</div>
        </div>
        <summary-row :symbol="item" v-for="(item,index) in symbols" :key="index"></summary-row>
    </div>
</template>
<script>
import SummaryPairRows from "./summaryPairsItems";
export default {
    components: {
        'summary-row':SummaryPairRows
    },
    data() {
        return {
           symbols:['EURUSD','GBPUSD','USDJPY','USDCHF','USDCAD','EURGBP'] 
        }
    }
}
</script>
<style lang="less" scoped>
.summaryPair {
    &-title {
        display:flex;
        width:100%;
        justify-content: space-between;
        border-bottom:1px solid #293546;
    }
    &-titleItem {
        font-family: Arimo;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.33;
        width: 80px;
        border-right: 1px solid #374b62;
        text-align: center;
        &:first-child {
            
        }
        &:last-child {
           
            width: 120px;
        }
    }
}
</style>


